import React from "react"

const Loader = () => {
  return (
     <div className="spinner-loader">
      <div className="video-spinner" />
    </div>
  )
}

export default Loader
